export default "__VITE_ASSET__BTycSKVE__"